// extracted by mini-css-extract-plugin
export default {"root":"ChatPinMessageConfirmationDialog_root__CHyJK"};